import CustomBadge from "@/components/desktop/badge/CustomBadge";

import styles from "./calendar-event-card.module.scss";

const resolveAccessor = (record, accessor) => {
	if (!accessor || !record) return undefined;
	if (typeof accessor === "function") return accessor(record);
	return record[accessor];
};

const resolveBadgeVariant = (badgeConfig, record) => {
	if (typeof badgeConfig.variant === "function") {
		const referenceValue = badgeConfig.variantAccessor
			? resolveAccessor(record, badgeConfig.variantAccessor)
			: resolveAccessor(record, badgeConfig.accessor);
		return badgeConfig.variant(referenceValue);
	}
	return badgeConfig.variant || "neutral";
};

const CalendarEventCard = ({ record, eventConfig = {}, borderLeftColor }) => {
	const { primary, secondary, badges = [] } = eventConfig;

	const primaryValue = primary ? resolveAccessor(record, primary.accessor) : record?.code;
	const primaryPrefix = primary?.prefix || "";
	const secondaryValue = secondary ? resolveAccessor(record, secondary.accessor) : null;

	const visibleBadges = badges
		.map((badgeConfig) => ({
			label: resolveAccessor(record, badgeConfig.accessor),
			variant: resolveBadgeVariant(badgeConfig, record),
		}))
		.filter((badge) => badge.label != null && badge.label !== "" && badge.label !== "-");

	return (
		<div className={styles.eventCard} style={borderLeftColor ? { borderLeftColor } : undefined}>
			<div className={styles.eventTitle}>
				{primaryPrefix}
				{primaryValue ?? "-"}
			</div>
			{secondaryValue && secondaryValue !== "-" && <div className={styles.eventSubtitle}>{secondaryValue}</div>}
			{visibleBadges.length > 0 && (
				<div className={styles.eventBadges}>
					{visibleBadges.map((badge, badgeIndex) => (
						<CustomBadge key={`${badge.label}-${badgeIndex}`} variant={badge.variant} size="sm">
							{badge.label}
						</CustomBadge>
					))}
				</div>
			)}
		</div>
	);
};

export default CalendarEventCard;
